<template>
	<aside
		class="fixed inset-y-0 z-50 flex h-dvh lg:hidden"
		:class="cn(isOpen ? 'w-screen' : 'w-0', variantClass)"
		:aria-hidden="!isOpen"
	>
		<div
			:class="
				sidebarClass({
					variant: `${props.variant}${isOpen ? 'Open' : 'Closed'}`
				})
			"
			aria-label="Menu lateral"
		>
			<header
				class="z-50 flex items-center justify-between border-b border-b-primary-light-4 px-5 py-[22px]"
			>
				<slot name="header" />
				<button
					aria-label="Fechar menu"
					class="size-6 cursor-pointer text-white"
					@click="isOpen = false"
				>
					<IconMaterialSymbolsLightClose />
				</button>
			</header>
			<main
				ref="navMobileGeneric"
				class="flex size-full flex-col overflow-y-auto pb-[87px]"
			>
				<slot name="content" />
			</main>
			<footer
				class="absolute bottom-0 flex w-full items-center justify-between border-t border-t-primary-light-4 bg-primary px-5 py-[22px]"
			>
				<slot name="footer" />
			</footer>
		</div>
		<div
			class="absolute bottom-0 z-10 h-dvh w-screen bg-primary/40"
			:class="isOpen ? 'block' : 'hidden'"
			@click="isOpen = false"
		/>
	</aside>
</template>

<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { cn } from '@/utils';
import { lock, clearBodyLocks, unlock } from 'tua-body-scroll-lock';

const props = defineProps<{
	variant: 'left' | 'right';
}>();

const isOpen = defineModel('isOpen', {
	type: Boolean,
	default: false
});

const navMobileGeneric = ref<HTMLElement | null>(null);

const sidebarClass = cva(
	'absolute top-0 z-50 h-dvh w-[319px] bg-primary transition-all duration-300',
	{
		variants: {
			variant: {
				leftClosed: 'left-[-320px]',
				rightClosed: 'right-[-319px]',
				leftOpen: 'left-0',
				rightOpen: 'right-0'
			}
		},
		defaultVariants: {
			variant: 'leftClosed'
		}
	}
);

const variantClass = computed(() =>
	props.variant === 'left' ? 'left-0' : 'right-0'
);

watch(isOpen, value => {
	if (value) {
		lock(navMobileGeneric.value);
		if (document.body.style.top) {
			document.body.style.removeProperty('top');
		}
	} else {
		unlock(navMobileGeneric.value);
	}
});

onBeforeUnmount(() => {
	clearBodyLocks();
});
</script>
